import React from 'react';
export interface IToolActionsContext {
  isReview: boolean;
  setIsReview: (value: boolean) => void;
  open: boolean;
  setOpen: (value: boolean) => void;
}

export const ToolActionsContext = React.createContext({} as IToolActionsContext);

export const ToolActionsContextProvider = ({ children }: any) => {
  const [isReview, setIsReview] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  return (
    <ToolActionsContext.Provider value={{ isReview, setIsReview, open, setOpen }}>
      {children}
    </ToolActionsContext.Provider>
  );
};
